<script setup>
import Button from 'next/button/Button.vue';
import { ref, onMounted } from 'vue';
defineProps({ count: { type: Number, required: true } });
defineEmits(['cancel', 'continue']);
const cancelButton = ref(null);
onMounted(() => cancelButton.value?.$el.focus());
</script>

<template>
  <div
    class="forward-selection-bar flex flex-wrap items-center justify-between gap-2 border-t border-n-weak p-3 bg-n-surface-1"
  >
    <span role="status" class="text-sm text-n-slate-12">{{
      $t('CONVERSATION.FORWARD.SELECTED', { count })
    }}</span>
    <div class="flex gap-2">
      <Button
        ref="cancelButton"
        :label="$t('CONVERSATION.FORWARD.CANCEL')"
        slate
        ghost
        class="min-h-11"
        @click="$emit('cancel')"
      />
      <Button
        :label="$t('CONVERSATION.FORWARD.CONTINUE')"
        icon="i-ph-arrow-right"
        trailing-icon
        :disabled="!count"
        class="min-h-11"
        @click="$emit('continue')"
      />
    </div>
  </div>
</template>

<style scoped>
.forward-selection-bar {
  padding-bottom: max(12px, env(safe-area-inset-bottom));
}
</style>
